/**
 * Reserved deep-link targets for Shipment / Notification (model only, no menu).
 * COMMERCE-MODEL-000001 + COMMERCE-WORKSPACE-000002.
 */
import { Link, useLocation } from 'react-router-dom';

export function CommercePlaceholderPage({ kind }: { kind: 'shipments' | 'notifications' }) {
  const loc = useLocation();
  const title = kind === 'shipments' ? 'Shipments' : 'Notifications';
  const entry = kind === 'shipments' ? 'Shipment ID' : 'Notification ID';

  return (
    <div className="mx-auto max-w-2xl space-y-4 p-6">
      <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-teal-700">
        Founder Commerce · Reserved
      </p>
      <h1 className="text-2xl font-semibold text-slate-900">{title}</h1>
      <p className="text-sm text-slate-600">
        This workspace is modeled in COMMERCE-MODEL-000001 and will use MarketSync when implemented.
        It is hidden from the menu (no dead founder links) and exists only so cross-navigation deep
        links do not 404.
      </p>
      <p className="rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-700">
        Entry object: <span className="font-mono font-medium">{entry}</span>
        <br />
        Path: <span className="font-mono text-xs">{loc.pathname}{loc.search}</span>
      </p>
      <nav className="flex flex-wrap gap-3 text-sm">
        <Link className="text-teal-800 underline-offset-2 hover:underline" to="/amazon/orders">
          Orders
        </Link>
        <Link className="text-teal-800 underline-offset-2 hover:underline" to="/amazon/inventory">
          Inventory
        </Link>
        <Link className="text-teal-800 underline-offset-2 hover:underline" to="/amazon/connect">
          Connect
        </Link>
      </nav>
    </div>
  );
}
